import { z } from 'zod';

import { type OffsetPaginationRequestQuery } from './pagination';
import { PrimaryKeySchema } from './utils';

export const AgentSchema = z.object({
  agentId: PrimaryKeySchema,
  teamId: PrimaryKeySchema,
  name: z.string().describe('The name of the agent'),
  description: z.string().nullable().describe('The description of the agent'),
  createdAt: z.coerce
    .date()
    .describe('The date and time the agent was created'),
  updatedAt: z.coerce
    .date()
    .describe('The date and time the agent was last updated'),
});

export type Agent = z.infer<typeof AgentSchema>;

export const ListAgentsOptionsSchema = z
  .object({
    teamIds: PrimaryKeySchema.array(),
    agentIds: PrimaryKeySchema.array(),
    nameLike: z.string().optional(),
  })
  .partial();

export type ListAgentsOptions = z.infer<typeof ListAgentsOptionsSchema> &
  OffsetPaginationRequestQuery<'name' | 'createdAt' | 'updatedAt'>;
